module.exports = __webpack_public_path__ + "static/media/gurukul1.ffb3a951.png";